import React, { useEffect, useState } from "react";
import "./LtrDetailTab.scss";
import ApiService from "../../services/apiService";
import URLS from "../../urls/Urls";
import { useParams } from "react-router-dom";
import { formatDate } from "../../utils/Helper";

interface ILTRDetail {
  id: number;
  name: string;
  department: string;
  budget: string;
  requester: string;
  workflow_name: string;
  created_at: string;
  request_attachments: { name: string; url: string }[];
  product_owner: string;
  description: string;
  guideline: string;
  workflow_attachments: { name: string; url: string }[];
}

interface LTRDetail {}
const LtrDetailTab: React.FC = () => {
  const [ltrDetails, setLtrDetails] = useState<ILTRDetail | null>(null);
  const { id } = useParams();

  useEffect(() => {
    getLtrDetails();
  }, []);

  const getLtrDetails = async () => {
    try {
      const { data } = await ApiService().client.get(
        URLS.WORKFLOW.REQUEST_DETAIL(Number(id)),
      );
      setLtrDetails(data.data);
    } catch (error) {
      console.error("Error Getting LTR Details", error);
    }
  };

  return (
    <div className="ltr-detail-main-container flex-column gap-8 full-width full-height border-box">
      <div className="request-detail-container full-width border-box">
        <p className="title req-title bolder xetgo-font-tag full-width px-16 py-12">
          Request Details
        </p>
        <div className="flex-column p-16 gap-24">
          <div className="flex-row gap-16">
            <div className="flex-column gap-8 xetgo-font-tag flex-1">
              <p className="title">Request Name</p>
              <p className="sub-title">{ltrDetails?.name}</p>
            </div>
            <div className="flex-column gap-8 flex-1 xetgo-font-tag">
              <p className="title">Department</p>
              <p className="sub-title">{ltrDetails?.department}</p>
            </div>
          </div>
          <div className="flex-column gap-8 flex-1 xetgo-font-tag">
            <p className="title">Budget</p>
            <p className="sub-title">INR {ltrDetails?.budget}</p>
          </div>
          <div className="flex-row gap-16">
            <div className="flex-column gap-8 xetgo-font-tag flex-1">
              <p className="title">Attachments</p>
              {ltrDetails && ltrDetails.request_attachments.length > 0 && (
                <div className="all-artwork-container flex-row gap-2">
                  {ltrDetails.request_attachments.map((file, fileIndex) => (
                    <div
                      onClick={() => window.open(file.url, "_blank")}
                      key={file.url}
                      className="artwork-file-container cursor-pointer flex-row gap-2 py-4 px-8 align-items-center justify-content-center"
                    >
                      <img
                        height={12}
                        width={12}
                        src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250310105117-paperclip.svg"
                        alt="attachment-icon"
                      />
                      <p>{file.name}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="flex-column gap-8 flex-1 xetgo-font-tag">
              <p className="title">Requester</p>
              <p className="sub-title">{ltrDetails?.requester}</p>
            </div>
          </div>
          <div className="flex-column gap-8 flex-1 xetgo-font-tag">
            <p className="title">Created Date</p>
            <p className="sub-title">
              {" "}
              {formatDate(ltrDetails?.created_at || "")}
            </p>
          </div>
        </div>
      </div>
      <div className="request-detail-container full-width border-box">
        <p className="title req-title bolder border-box xetgo-font-tag full-width px-16 py-12">
          Workflow Details
        </p>
        <div className="flex-column p-16 gap-24">
          <div className="flex-row gap-16">
            <div className="flex-column gap-8 xetgo-font-tag flex-1">
              <p className="title">Workflow Name</p>
              <p className="sub-title">{ltrDetails?.workflow_name}</p>
            </div>
            <div className="flex-column gap-8 flex-1 xetgo-font-tag">
              <p className="title">Product Owner</p>
              <p className="sub-title">{ltrDetails?.product_owner}</p>
            </div>
          </div>
          <div className="flex-column gap-8 flex-1 xetgo-font-tag">
            <p className="title">Description</p>
            <p className="sub-title"> {ltrDetails?.description}</p>
          </div>

          <div className="flex-column gap-8 flex-1 xetgo-font-tag">
            <p className="title">Guidelines</p>
            <div
              dangerouslySetInnerHTML={{ __html: ltrDetails?.guideline || "" }}
              className="sub-title"
            ></div>
          </div>

          <div className="flex-row gap-16">
            <div className="flex-column gap-8 xetgo-font-tag flex-1">
              <p className="title">Document Attachments</p>
              {ltrDetails && ltrDetails.workflow_attachments.length > 0 && (
                <div className="all-artwork-container flex-row gap-2">
                  {ltrDetails.workflow_attachments.map((file, fileIndex) => (
                    <div
                      onClick={() => window.open(file.url, "_blank")}
                      key={file.url}
                      className="artwork-file-container cursor-pointer flex-row gap-2 py-4 px-8 align-items-center justify-content-center"
                    >
                      <img
                        height={12}
                        width={12}
                        src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20250310105117-paperclip.svg"
                        alt="attachment-icon"
                      />
                      <p>{file.name}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LtrDetailTab;
